import { useEffect, useState } from 'react'
import { storeSessionData } from 'api/utils/apollo/session/sessionToken.utils'

export const useStoreSessionToken = (token: string | undefined) => {
  const [tokenStored, setTokenStored] = useState<boolean>(false)

  useEffect(() => {
    async function saveSessionData() {
      if (token) {
        await storeSessionData({ token })

        setTokenStored(true)
      }
    }

    saveSessionData()
  }, [token])

  return {
    completed: tokenStored,
  }
}
